import * as React from 'react'
import styled from 'styled-components'
import LinkArrow from 'assets/link-arrow.svg'
import theme from 'theme'
import Link from 'theme/atoms/Link'

type Props = {
  backLink: string
  backLabel: string
}

export default function MobileBacklink(props: Props) {
  return (
    <Wrapper className="MobileBacklink" to={props.backLink}>
      <LinkArrow />
      {props.backLabel}
    </Wrapper>
  )
}

const Wrapper = styled(Link)`
  ${theme.ty('rc-base', 'bold')}
  font-size: 14px;
  display: flex;
  align-items: center;
  > svg {
    margin-right: ${theme.spacing('xs')};
    transform: rotate(180deg);
    width: 14px;
    margin-bottom: -2px;
  }
`
